// extracted by mini-css-extract-plugin
export default {"body":"UpdateModal-module__body"};